export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f522646f9f10b0fdd2525c50b3ff259f5b14ac080&name=fetchTypeahead!'